
import { mapState } from 'vuex';
import FilterSelect from "/components/filters/FilterSelect.vue";
import FilterCheckbox from "/components/filters/FilterCheckbox.vue";
import SimplePropertyList from "@/components/properties/property-list-page/SimplePropertyList";

import gtag from "@/mixins/gtag";

import {
  GET_PROPERTIES_PAGINATION
} from '~/store/properties/constants';

import {
  GET_AMENITIES,
} from '~/store/amenities/constants';

export default {
  name: "PropertiesListIndex",
  components: {
    FilterSelect,
    FilterCheckbox,
    SimplePropertyList
  },
  middleware: [
    'load-page-blocks'
  ],
  mixins: [
    gtag,
  ],
  data() {
    return {
      filters: {
        destinations: [],
        amenities: [],
        type: null,
      }
    }
  },
  head() {
    return {
      title: this.network?.name ? `${this.network.name} - ${this.$t("main.properties_list.properties_found", {count: this.pagination.total})}`: `${this.$t("main.properties_list.properties_found", {count: this.pagination.total})}`,
      meta: [
        { hid: 'og:title', name: 'og:title', content: this.network?.name ? `${this.network.name} - ${this.$t("main.properties_list.properties_found", {count: this.pagination.total})}` : 'Booking Engine' },
        { hid: 'og:description', name: 'og:description',
          content:
          `${this.network.name}: ${this.properties.map(a => a.name).join(', ')} |
          ${this.$t('properties.unit_categories.amenities')}: ${this.amenities.length ? this.amenities.map(a => a.name).join(', ') : ''}. |
          ${this.properties.map(a => a.name).join(', ')}
          `
        },
        { hid: 'description', name: 'description',
          content:
          `${this.network.name}: ${this.properties.map(a => a.name).join(', ')} |
          ${this.$t('properties.unit_categories.amenities')}: ${this.amenities.length ? this.amenities.map(a => a.name).join(', ') : ''}. |
          ${this.properties.map(a => a.name).join(', ')}
          `
        },
        {
          hid: 'og:image',
          name: 'og:image',
          content: this.network.images?.length ? this.network.images[0].sizes_full_path.high : 'https://source.unsplash.com/random/800%C3%97800/?travel' ,
        }
      ],
    }
  },
  created() {
    if (this.network && this.network.default_search === this.$const('default_search', 'GRID_MAP')) {
      this.isShowMap = true;
    }
    this.$store.dispatch(GET_AMENITIES);
  },
  mounted() {
    this.getData();
  },
  methods: {
    async paginate(page) {
      await this.$store.dispatch(GET_PROPERTIES_PAGINATION, {
        page,
        ...this.filters
      });
    },
    async getData() {
      await this.$store.dispatch(GET_PROPERTIES_PAGINATION, {
        ...this.filters
      });
    },
    prevPage() {
      if (this.pagination.page === 1) {
        return;
      }

      this.paginate(this.pagination.page - 1);
    },
    nextPage() {
      if (this.pagination.is_last) {
        return;
      }

      this.paginate(this.pagination.page + 1);
    },
  },
  computed: {
    propertyListLayout() {
      return this.isSimpleView ? 'SimplePropertyList' : 'PropertyListWithUnitCategory';
    },
    amenities() {
      return this.amenitiesList.map(item => {
        return {
          id: item.id,
          name: item.key,
        }
      })
    },
    types() {
      let items = [];
      const trans = this.$t('constants.room_types');

      this.includedRoomTypes.map(item => {
        items.push({
          id: item,
          name: !!trans[item] ? trans[item] : ''
        });
      });

      return items;
    },
    ...mapState({
      loading: state => state.properties.getPaginationRequest.loading,
      properties: state => state.properties.getPaginationRequest.collection || [],
      pagination: state => state.properties.getPaginationRequest.pagination || [],
      network: state => state['booking-networks'].getBookingNetworksRequest.data,
      amenitiesList: state => state.amenities.getAmenitiesRequest.data,
      includedRoomTypes: state => state.data.getConfigRequest.data.room_types || [],
    }),
    hasFilters() {
      return !!this.network.is_show_properties_list_filters;
    },
    isNoResults() {
      return !this.properties.length;
    }
  },
  watch: {
    filters: {
      handler() {
        this.getData();
      },
      deep: true
    }
  }
};
